<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page template-padding container" v-else-if="loaded" >
        
        <!-- NEW -->
        <div class="row col-12" >
            <b-card no-body class="atlass-tabs col-12" >
                <b-tabs card>
                    
                    <!--
                    <b-tab title="Advanced ( Recomended )"  >
                        <b-card-text>
                
                            <div class="col-12" > 
                                In order to ensure that the scripts doesn't get blocked by extensions or other script blockers, we need to create a subdomain that points to our domain. For the subdomain, you can put anything as long as it's not used. For example, <b>e.domain.com</b> or <b>event.domain.com</b> 
                                <br><br>
                                Go to your DNS settings, inside your hosting provider's control panel and create a new Record:
                                <br><br>
                                Name: <b>e.domain.com</b> or <b>event.domain.com</b> 
                                <br>
                                Record Type: CNAME
                                <br>
                                TTL: 5
                                <br> 
                                TTL Unit: minutes
                                <br>
                                Canonical name: sql.theatlass.com
                            </div>
                            
                            <div class="form-group col-12" > 
                                <label> Paste here the subdomain you created </label>
                                <input type="text" class="from-control col-12" v-model="domain" />
                            </div>
                            
                            <div class="col-12 mt-4" v-if="domain != '' " >
                
    <pre id="script" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border" v >
        &lt;script&gt;
            window.atlassSettings = {
                APPKEY: "{{data.organizationID}}",
                tags: 'primary',
            }
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://{{domain}}/t/t.min.js";
            document.head.appendChild(s);
        &lt;/script&gt;
    </pre>
                
                            </div>

                            <div class="col-12 text-center" v-if="domain != '' " >
                                <button class="btn btn-primary" @click="copyScript()" > Copy script </button>
                            </div>
                            
                        </b-card-text>
                    </b-tab>
                    
                    -->
                    
                    <b-tab title="Script" >
                        
                        
                        <div class="col-12" >
                
    <pre id="script" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border">
        &lt;script&gt;
            window.atlassSettings = {
                APPKEY: "{{data.organizationID}}",
                tags: 'primary',
            }
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://theatlass.com/t/t.min.js";
            document.head.appendChild(s);
        &lt;/script&gt;
    </pre>

                        </div>

                        <div class="col-12 text-center" >
                            <button class="btn btn-primary" @click="copyScript()" > Copy script </button>
                        </div>
                        
                        
                    </b-tab>
                    
                    
                    <b-tab title="Credentials" >
                        
                        <div class="col-12 col-md-6 offset-md-3" >

                            <div class="form-group col-12" > 
                                <label> APPKEY </label>
                                <input type="text" class="from-control col-12" v-model="data.APPKEY" />
                            </div>

                            <div class="form-group col-12" > 
                                <label> APP SECRET </label>
                                <input type="text" class="from-control col-12" v-model="data.SECRET_KEY" />
                            </div>

                        </div>
                        
                    </b-tab>
                    
                </b-tabs>
            </b-card>
        </div>
        <!-- NEW -->

        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';

export default {
    name: 'Tracking',
    components:{
        
    },
    props: {
    },
    data: function(){
        return {
            loaded: false,
            data:{},
            domain:""
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //this.get_data();
        
        //let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        //this.data.organizationID = orgID;
        
        //setTimeout(function(){ this.loaded = true }.bind(this), 100 );
        
        this.get_organization()
    },
    beforeDestroy() {
    },
    methods: {
         get_data(){
          
            if( !Cookies.get('user') ){
                return false
            }
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )
                        
            const db = firebase.firestore();
            var ref = db.collection('users').doc( user.userID )
            
            return ref.get()
                .then((snapshot) => {
                    console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.id = snapshot.id
                    this.loaded = true;
                })
          
        },
         get_organization(){
          
            if( !Cookies.get('user') ){
                return false
            }
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )
                        
            const db = firebase.firestore();
            var ref = db.collection('organizations').doc( user.organizationID )
            
            return ref.get()
                .then((snapshot) => {
                    //console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.organizationID =  snapshot.id
                    this.loaded = true;
                })
          
        },
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        routePrimaryLead(ID){
            this.$router.push({
                name: 'LeadPage',
                params: { ID: ID }
            });
        },
        submit(){
            console.log( this.data )
        },
        copyScript(){
            
            var range = document.createRange();
            range.selectNode(document.getElementById("script"));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        }
    },
    watch: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/Tracking.vue